import { render, staticRenderFns } from "./WhsL_Search.vue?vue&type=template&id=15bc1b09"
import script from "./WhsL_Search.vue?vue&type=script&lang=js"
export * from "./WhsL_Search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports